export default "__VITE_ASSET__B4JBV_f0__"